import SelectGenderQuestion from "./components/SelectGenderQuestion"
import EmailQuestion from './components/EmailQuestion';
import SelectPasswordQuestion from './components/SelectPasswordQuestion';
import SelectNicknameQuestion from './components/SelectNicknameQuestion';
import BirthdateQuestion from './components/BirthdateQuestion';
import LookingForQuestion from './components/LookingForQuestion';
import LocationQuestion from './components/LocationQuestion';
import ProfileImageQuestion from './components/ProfileImageQuestion';
import PersonalStatusQuestion from './components/PersonalStatusQuestion';
import { HOMEPAGE, ONBORADING_SCREEN } from "../../navigation/Constants";
import { useHistory } from 'react-router-dom';
import StepperPage from '../../components/stepper/StepperPage';
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import AboutMeQuestion from "../Home/components/AboutMeQuestion";
import { useEffect } from "react";
import { getJwt } from "../../services/accountService";
import SelectHeightQuestion from "./components/HeightQuestion";
import PhoneVerficationSms from "./components/PhoneVerficationSms";


export function SingupContainer() {
   const register = useSelector((state: RootState) => state.signup);
   let history = useHistory();
   useEffect(() => {
      const token = getJwt();
      if (token) history.replace(HOMEPAGE);
   }, [])

   let signUpQuestions = [


      {
         component: SelectGenderQuestion,
         title: "SelectGenderQuestion"
      },
      {
         component: EmailQuestion,
         title: "EmailQuestion"
      },
      {
         component: SelectPasswordQuestion,
         title: "SelectPasswordQuestion"
      },
      {
         component: PhoneVerficationSms,
         title: "PhoneVerficationSms"
      },
      {
         component: SelectNicknameQuestion,
         title: "SelectNicknameQuestion"
      },
      {
         component: LookingForQuestion,
         title: "LookingForQuestion"
      },
      {
         component: LocationQuestion,
         title: "LocationQuestion"
      },
      {
         component: BirthdateQuestion,
         title: "BirthdateQuestion"
      },
      {
         component: SelectHeightQuestion,
         title: "SelectHeightQuestion"
      },
      {
         component: PersonalStatusQuestion,
         title: "PersonalStatusQuestion"
      },
      {
         component: AboutMeQuestion,
         title: 'AboutMeQuestion'
      },
      {
         component: ProfileImageQuestion,
         title: "ProfileImageQuestion"
      },
   ]

   if (register.registrationTypeId !== 1) {
      signUpQuestions = signUpQuestions.filter(q => q.component !== SelectPasswordQuestion)
   }

   const navigateToLoginPage = () => {
      history.replace(ONBORADING_SCREEN);
   }

   return (
      <>
         <div>
            <StepperPage
               containStepperHeader={true}
               components={signUpQuestions}
               handleBackBrowserButton={true}
               hasBackButton={true}
               onClose={navigateToLoginPage}
            />
         </div>
      </>
   )
}